import Icon from "@/v2-ui/icon"
import Badge from "@/v2-backoffice-client/components/badge"
import type { UserMfaQuery } from "@/v2-backoffice-client/user/mfa/__types__/user.mfa.query"
import {
  getPhoneTypeLabel,
  getSmsSignInStateInfo,
} from "@/v2-backoffice-client/user/mfa/user.mfa.utils"
import UserMfaEditPhone from "@/v2-backoffice-client/user/mfa/UserMfaEditPhone"
import UserMfaDeletePhone from "@/v2-backoffice-client/user/mfa/UserMfaDeletePhone"

type Method = UserMfaQuery["getUserMfa"]["Methods"][number]

export type UserMfaMethodCardProps = {
  userId: number
  method: Method
  onChanged?(): void
}

// Presentational row for one registered phone method; the edit/delete actions
// are self-contained components that each own their own mutation.
function UserMfaMethodCard(props: UserMfaMethodCardProps) {
  const { userId, method, onChanged } = props

  const typeLabel = getPhoneTypeLabel(method.PhoneType)
  const smsState = getSmsSignInStateInfo(method.SmsSignInState)

  return (
    <div className="flex items-center justify-between gap-3 rounded-md border bg-muted/20 px-3 py-2.5">
      <div className="flex min-w-0 items-center gap-3">
        <span className="flex size-9 shrink-0 items-center justify-center rounded-full bg-muted text-muted-foreground">
          <Icon src="mobile" size={16} />
        </span>
        <div className="flex min-w-0 flex-col gap-0.5">
          <span className="truncate font-medium tabular-nums">
            {method.PhoneNumber}
          </span>
          <div className="flex flex-wrap items-center gap-1.5 text-xs text-muted-foreground">
            <span>{typeLabel}</span>
            {smsState && (
              <>
                <span aria-hidden>·</span>
                <Badge
                  size="tiny"
                  variant={smsState.variant}
                  tooltip={smsState.description}
                >
                  {smsState.label}
                </Badge>
              </>
            )}
          </div>
        </div>
      </div>

      <div className="flex shrink-0 items-center gap-1">
        <UserMfaEditPhone
          userId={userId}
          methodId={method.Id}
          currentPhoneNumber={method.PhoneNumber}
          onCompleted={onChanged}
        />
        <UserMfaDeletePhone
          userId={userId}
          methodId={method.Id}
          phoneNumber={method.PhoneNumber}
          onCompleted={onChanged}
        />
      </div>
    </div>
  )
}

export default UserMfaMethodCard
